import { isNaN } from 'lodash';

/**
 * Merges a date and a `HH:mm` time into a single Date, at whole minutes.
 *
 * Seconds and milliseconds are always zeroed. Bookings are only ever selected to the minute, but
 * the payload is serialised with `HH:mm:ss`, and callers routinely pass a raw `new Date()` as the
 * base date (the `?? new Date()` fallbacks in the filter and flow date pickers) — so anything left
 * on the base date would reach the backend as a stray seconds value. A seconds component in
 * `time` is ignored for the same reason.
 *
 * An absent or unparseable time falls back to midnight rather than producing an `Invalid Date`.
 */
export const mergeDateTime = (date: Date, time?: string): Date => {
  const [hours, minutes] = (time ?? '').split(':');
  const merged = new Date(date);

  if (isNaN(Number(hours)) || isNaN(Number(minutes))) {
    return new Date(merged.setHours(0, 0, 0, 0));
  }

  return new Date(merged.setHours(Number(hours), Number(minutes), 0, 0));
};
